import React, { useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
};

export default function GuiaRemision() {

  const [guias, setGuias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [facturas, setFacturas] = useState([]);

  const [transportista, setTransportista] = useState({ nombre: "", razonSocial: "", ruc: "", email: "", telefono: "" });
  const [placa, setPlaca] = useState("");
  const [dirPartida, setDirPartida] = useState("");
  const [fechaIni, setFechaIni] = useState(new Date().toISOString().split("T")[0]);
  const [fechaFin, setFechaFin] = useState(new Date().toISOString().split("T")[0]);
  const [firmaPassword, setFirmaPassword] = useState("");

  const [destinatarios, setDestinatarios] = useState([{
    identificacion: "", razonSocial: "", nombre: "", direccion: "", motivoTraslado: "Venta de mercadería",
    codDocSustento: "01", numDocSustento: "", numAutDocSustento: "", fechaEmisionDocSustento: "",
    detalles: [{ codigo: "", descripcion: "", cantidad: 1 }]
  }]);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/guias-remision`, { headers: getAuthHeaders() });
      const data = await res.json();
      setGuias(Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : []);
      
      // Cargar facturas para el selector
      const facRes = await fetch(`${API}/api/facturas`, { headers: getAuthHeaders() });
      const facData = await facRes.json();
      setFacturas(Array.isArray(facData) ? facData : []);
    } catch (e) { setError(e.message); }
    setLoading(false);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  // Seleccionar factura y auto-llenar destinatario
  const seleccionarFactura = (factura) => {
    if (!factura) return;
    
    setDestinatarios([{
      identificacion: factura.cliente?.ruc || factura.cliente?.identificacion || "",
      razonSocial: factura.cliente?.nombre || factura.cliente?.razonSocial || "",
      nombre: factura.cliente?.nombre || "",
      direccion: factura.cliente?.direccion || "",
      motivoTraslado: "Venta de mercadería",
      codDocSustento: "01",
      numDocSustento: factura.secuencial ? `001-001-${String(factura.secuencial).padStart(9, "0")}` : "",
      numAutDocSustento: factura.claveAcceso || "",
      fechaEmisionDocSustento: factura.fechaEmision || "",
      detalles: [{ codigo: "", descripcion: "", cantidad: 1 }]
    }]);
  };

  const actualizarDestinatario = (idx, campo, valor) => {
    const copia = [...destinatarios];
    copia[idx] = { ...copia[idx], [campo]: valor };
    setDestinatarios(copia);
  };

  const actualizarDetalleDest = (destIdx, detIdx, campo, valor) => {
    const copia = [...destinatarios];
    copia[destIdx].detalles[detIdx] = { ...copia[destIdx].detalles[detIdx], [campo]: valor };
    setDestinatarios(copia);
  };

  const agregarDetalleDest = (destIdx) => {
    const copia = [...destinatarios];
    copia[destIdx].detalles.push({ codigo: "", descripcion: "", cantidad: 1 });
    setDestinatarios(copia);
  };

  const crear = async () => {
    if (!transportista.nombre && !transportista.razonSocial) { setError("Ingrese datos del transportista"); return; }
    if (!transportista.ruc) { setError("RUC/CI del transportista es requerido"); return; }
    setLoading(true); setError(""); setMsg("");
    try {
      const body = {
        transportista: { ...transportista, razonSocial: transportista.razonSocial || transportista.nombre },
        destinatarios, fechaIniTransporte: fechaIni, fechaFinTransporte: fechaFin, placa, dirPartida, firmaPassword
      };
      const res = await fetch(`${API}/api/guias-remision`, { method: "POST", headers: getAuthHeaders(), body: JSON.stringify(body) });
      const data = await res.json();
      if (data.success) {
        setMsg("Guía de remisión generada exitosamente. " + (data.message || ""));
        setShowForm(false);
        setTransportista({ nombre: "", razonSocial: "", ruc: "", email: "", telefono: "" });
        setDestinatarios([{ identificacion: "", razonSocial: "", nombre: "", direccion: "", motivoTraslado: "Venta de mercadería", codDocSustento: "01", numDocSustento: "", numAutDocSustento: "", fechaEmisionDocSustento: "", detalles: [{ codigo: "", descripcion: "", cantidad: 1 }] }]);
        cargar();
      } else { setError(data.error || "Error"); }
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  const estadoColor = (e) => e === "AUTORIZADO" ? "#4caf50" : e === "PENDIENTE" ? "#ff9800" : e === "ANULADA" ? "#9e9e9e" : "#f44336";

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>🚚 Guías de Remisión</h2>
        <button onClick={() => setShowForm(!showForm)} style={btnPrimary}>{showForm ? "Cancelar" : "+ Nueva Guía"}</button>
      </div>

      {msg && <div style={{ background: "#e8f5e9", padding: 12, borderRadius: 8, marginBottom: 16, color: "#2e7d32" }}>{msg}</div>}
      {error && <div style={{ background: "#ffebee", padding: 12, borderRadius: 8, marginBottom: 16, color: "#c62828" }}>{error}</div>}

      {showForm && (
        <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 12, padding: 24, marginBottom: 24 }}>
          <h3>Nueva Guía de Remisión</h3>

          {/* Selector de Factura */}
          <div style={{ background: "#e3f2fd", padding: 16, borderRadius: 8, marginBottom: 20, border: "1px solid #90caf9" }}>
            <label style={{ ...labelStyle, fontWeight: 600, fontSize: 14 }}>📄 Seleccionar Factura (opcional - auto-llena destinatario y mercadería)</label>
            <select
              style={{ ...inputStyle, marginTop: 8 }}
              onChange={(e) => {
                const fac = facturas.find(f => (f.claveAcceso || f.id) === e.target.value);
                if (fac) seleccionarFactura(fac);
              }}
              defaultValue=""
            >
              <option value="">-- Seleccione una factura --</option>
              {facturas.map((f, i) => (
                <option key={f.claveAcceso || i} value={f.claveAcceso || f.id}>
                  Nº {String(f.secuencial || "").padStart(9, "0")} — {f.cliente?.nombre || "Sin cliente"} — ${f.totales?.valorPagar || f.totales?.importeTotal || "0.00"} — {f.fechaEmision || ""}
                </option>
              ))}
            </select>
          </div>

          <h4>Datos del Transportista</h4>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
            <div>
              <label style={labelStyle}>Nombre / Razón Social *</label>
              <input value={transportista.nombre} onChange={e => setTransportista({ ...transportista, nombre: e.target.value, razonSocial: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>RUC / Cédula *</label>
              <input value={transportista.ruc} onChange={e => setTransportista({ ...transportista, ruc: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Placa del Vehículo *</label>
              <input value={placa} onChange={e => setPlaca(e.target.value.toUpperCase())} style={inputStyle} placeholder="ABC-1234" />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginTop: 12 }}>
            <div>
              <label style={labelStyle}>Dirección de Partida</label>
              <input value={dirPartida} onChange={e => setDirPartida(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Fecha Inicio Transporte *</label>
              <input type="date" value={fechaIni} onChange={e => setFechaIni(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Fecha Fin Transporte *</label>
              <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} style={inputStyle} />
            </div>
          </div>

          {destinatarios.map((dest, di) => (
            <div key={di} style={{ background: "#f9f9f9", padding: 16, borderRadius: 8, marginTop: 20, border: "1px solid #e0e0e0" }}>
              <h4 style={{ margin: "0 0 12px" }}>Destinatario {di + 1}</h4>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                <div>
                  <label style={labelStyle}>Nombre / Razón Social *</label>
                  <input value={dest.razonSocial || dest.nombre} onChange={e => actualizarDestinatario(di, "razonSocial", e.target.value)} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>RUC / Cédula *</label>
                  <input value={dest.identificacion} onChange={e => actualizarDestinatario(di, "identificacion", e.target.value)} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Dirección Destino *</label>
                  <input value={dest.direccion} onChange={e => actualizarDestinatario(di, "direccion", e.target.value)} style={inputStyle} />
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginTop: 8 }}>
                <div>
                  <label style={labelStyle}>Motivo Traslado</label>
                  <select value={dest.motivoTraslado} onChange={e => actualizarDestinatario(di, "motivoTraslado", e.target.value)} style={inputStyle}>
                    <option>Venta de mercadería</option><option>Traslado entre establecimientos</option>
                    <option>Devolución</option><option>Transformación</option><option>Consignación</option><option>Otros</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>No. Factura Asociada</label>
                  <input value={dest.numDocSustento} onChange={e => actualizarDestinatario(di, "numDocSustento", e.target.value)} style={inputStyle} placeholder="001-001-000000001" />
                </div>
                <div>
                  <label style={labelStyle}>Clave Acceso Factura</label>
                  <input value={dest.numAutDocSustento} onChange={e => actualizarDestinatario(di, "numAutDocSustento", e.target.value)} style={inputStyle} />
                </div>
              </div>

              <h5 style={{ marginTop: 12 }}>Mercadería</h5>
              {dest.detalles.map((det, detI) => (
                <div key={detI} style={{ display: "grid", gridTemplateColumns: "100px 1fr 80px 40px", gap: 8, marginBottom: 6 }}>
                  <input value={det.codigo} onChange={e => actualizarDetalleDest(di, detI, "codigo", e.target.value)} placeholder="Código" style={inputStyle} />
                  <input value={det.descripcion} onChange={e => actualizarDetalleDest(di, detI, "descripcion", e.target.value)} placeholder="Descripción" style={inputStyle} />
                  <input type="number" value={det.cantidad} onChange={e => actualizarDetalleDest(di, detI, "cantidad", parseFloat(e.target.value) || 0)} style={inputStyle} />
                  <button onClick={() => { const c = [...destinatarios]; c[di].detalles = c[di].detalles.filter((_, j) => j !== detI); setDestinatarios(c); }} style={{ ...btnDanger, padding: "4px 8px" }}>✕</button>
                </div>
              ))}
              <button onClick={() => agregarDetalleDest(di)} style={btnSecondary}>+ Agregar producto</button>
            </div>
          ))}

          <button onClick={() => setDestinatarios([...destinatarios, { identificacion: "", razonSocial: "", nombre: "", direccion: "", motivoTraslado: "Venta de mercadería", codDocSustento: "01", numDocSustento: "", numAutDocSustento: "", fechaEmisionDocSustento: "", detalles: [{ codigo: "", descripcion: "", cantidad: 1 }] }])} style={{ ...btnSecondary, marginTop: 12 }}>+ Agregar Destinatario</button>

          <div style={{ marginTop: 16 }}>
            <label style={labelStyle}>Contraseña de Firma (opcional)</label>
            <input type="password" value={firmaPassword} onChange={e => setFirmaPassword(e.target.value)} style={{ ...inputStyle, maxWidth: 300 }} />
          </div>

          <button onClick={crear} disabled={loading} style={{ ...btnPrimary, marginTop: 16 }}>{loading ? "Procesando..." : "Generar y Enviar al SRI"}</button>
        </div>
      )}

      <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden", border: "1px solid #e0e0e0" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f5f5f5" }}>
              <th style={thStyle}>Número</th><th style={thStyle}>Fecha</th><th style={thStyle}>Transportista</th>
              <th style={thStyle}>Placa</th><th style={thStyle}>Destinatarios</th><th style={thStyle}>Estado SRI</th><th style={thStyle}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {guias.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: "center", padding: 24, color: "#999" }}>No hay guías de remisión registradas</td></tr>
            ) : guias.map(g => (
              <tr key={g.id} style={{ borderBottom: "1px solid #eee" }}>
                <td style={tdStyle}>{g.numero}</td>
                <td style={tdStyle}>{g.fecha_emision}</td>
                <td style={tdStyle}>{g.transportista?.nombre || g.transportista?.razonSocial}</td>
                <td style={tdStyle}>{g.placa}</td>
                <td style={tdStyle}>{g.destinatarios?.length || 0}</td>
                <td style={tdStyle}><span style={{ background: estadoColor(g.autorizacion?.estado || g.estado_sri || g.estado || "PENDIENTE"), color: "#fff", padding: "2px 8px", borderRadius: 12, fontSize: 12 }}>{g.autorizacion?.estado || g.estado_sri || g.estado || "PENDIENTE"}</span></td>
                <td style={tdStyle}>
                  <button onClick={async () => {
                    try {
                      const token = localStorage.getItem("token");
                      const response = await fetch(`${API}/api/guias-remision/${g.id}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
                      if (!response.ok) throw new Error("Error");
                      const blob = await response.blob();
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a"); a.href = url; a.setAttribute("download", `guia_remision_${g.numero}.pdf`);
                      document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url);
                    } catch (e) { setError("Error al descargar PDF"); }
                  }} style={btnSmall}>PDF</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const btnPrimary = { background: "#1976d2", color: "#fff", border: "none", padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 14 };
const btnSecondary = { background: "#f5f5f5", color: "#333", border: "1px solid #ddd", padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 13 };
const btnDanger = { background: "#f44336", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" };
const btnSmall = { background: "#1976d2", color: "#fff", border: "none", padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontSize: 12 };
const inputStyle = { width: "100%", padding: "8px 12px", border: "1px solid #ddd", borderRadius: 8, fontSize: 14, boxSizing: "border-box" };
const labelStyle = { display: "block", marginBottom: 4, marginTop: 8, fontWeight: 600, fontSize: 13 };
const thStyle = { padding: "10px 12px", textAlign: "left", fontSize: 13, fontWeight: 600 };
const tdStyle = { padding: "10px 12px", fontSize: 13 };
